module.exports = __webpack_public_path__ + "media/stylesheets/images/main/openWaiting/openWaiting_pc_sung-af0bca7b8c81871b4017522be6caa33a.png";